import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  FeatureCard,
  CardsContainer,
  StyledTitle,
  StyledBody,
  StyledImage,
  HeaderContainer,
  Heading,
  HeadingImage,
  HighlightedText
} from '../styles/FeatureSection';
import connitLogo from '../assets/images/logo/logo.png';
import features from '../utils/features';  

const FeatureSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // Slice the features array to show only 2 cards on small screens
  const displayedFeatures = isSmallScreen ? features.slice(0, 2) : features;

  return (
    <>
      <HeaderContainer>
        <HeadingImage src={connitLogo} alt="Connit Labs Logo" />
        <Heading variant='h4'>
          How can I help you <HighlightedText>today?</HighlightedText>
        </Heading>
      </HeaderContainer>

      <CardsContainer>
        {displayedFeatures.map((feature, index) => (
          <FeatureCard key={index}>
            <StyledImage src={feature.image} alt={feature.alt} />
            <StyledTitle>{feature.title}</StyledTitle>
            <StyledBody>{feature.body}</StyledBody>
          </FeatureCard>
        ))}
      </CardsContainer>
    </>
  );
};

export default FeatureSection;
